import React from 'react';
import PropTypes from 'prop-types';

const UPLOAD_COMPANY_LOGO = 'uploadCompanyLogo';
const REMOVE_COMPANY_LOGO = 'removeCompanyLogo';

export default class HomeLogoUpload extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    isProviderAdmin: PropTypes.bool.isRequired,
    toggleDialogFunction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    const uploadDialogId = UPLOAD_COMPANY_LOGO;
    const removeDialogId = REMOVE_COMPANY_LOGO;

    this.removeLogo = this.removeLogo.bind(this, removeDialogId);
    this.uploadLogo = this.uploadLogo.bind(this, uploadDialogId);
  }

  shouldComponentUpdate = nextProps => {
    const { account } = this.props;
    const {
      account: { logoUrl },
    } = nextProps;
    if (account.logoUrl !== logoUrl) return true;
    return false;
  };

  uploadLogo(id) {
    // TODO WIRE THIS UP WHEN BACKEND IS READY
    const { toggleDialogFunction } = this.props;
    toggleDialogFunction(id);
  }

  removeLogo(id) {
    const { toggleDialogFunction } = this.props;
    toggleDialogFunction(id);
  }

  render() {
    const { account, isProviderAdmin } = this.props;

    return (
      <div>
        {isProviderAdmin ? (
          <div>
            {account.logoUrl ? (
              <img
                src={`${account.logoUrl ? account.logoUrl : '400x100placeholder.png'}`}
                width="80"
                height="35"
                alt="company logo"
                className="img-responsive"
              />
            ) : null}
            {account.logoUrl ? (
              <button
                type="button"
                className="btn btn-secondary btn-link remove-button-css pl-2"
                onClick={this.removeLogo}
              >
                Remove
              </button>
            ) : null}
            <button
              type="button"
              className={`btn btn-secondary btn-link remove-button-css ${
                account.logoUrl ? 'pl-2' : null
              }`}
              onClick={this.uploadLogo}
            >
              Upload
            </button>
          </div>
        ) : null}
      </div>
    );
  }
}
